import { render, staticRenderFns } from "./ProfileOrganization.vue?vue&type=template&id=903d3938&scoped=true"
import script from "./ProfileOrganization.vue?vue&type=script&lang=js"
export * from "./ProfileOrganization.vue?vue&type=script&lang=js"
import style0 from "./ProfileOrganization.vue?vue&type=style&index=0&id=903d3938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903d3938",
  null
  
)

export default component.exports